<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.title = $_('MarchRecall');
        itemDetails.description = $_('MarchRecallDescription');
        itemDetails.icon = 'marchRecall';
        itemDetails.amount = item.amount;
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
